module.exports = __webpack_public_path__ + "img/vegetable-cardoons-350x184.211bb104.jpg";